import { useCallback, useContext, useEffect, useState } from "react";
import { useLocale, useService, useAppContext } from "../../../../hooks";
import { NavigatorContext } from "../../../../context";

export const useBookServiceForm = () => {
  const {
    actions: { setServices },
    selectors: { getServices },
  } = useAppContext();
  const { t } = useLocale();
  const { fetchByAttr } = useService("Data", "city");
  const { getServices: fetchServices } = useService("Service");
  const { setActiveLocation: setLocation, getActiveLocation: getLocation } =
    useService("Misc");
  const { getCarManufacturers: getManufacturers } = useService("Car");
  const { setActiveCar, showAlert } = useService("Misc");
  const { fetchByAttr: fetchCarByAttr } = useService("Data", "carModel");
  const [activeCarBrand, setactiveCarBrand] = useState(null);
  const [activeCarModel, setactiveCarModel] = useState(null);
  const [activeService, setactiveService] = useState(null);
  const [activeLocation, setactiveLocation] = useState(getLocation());
  const [carBrands, setcarBrands] = useState([]);
  const [carModels, setcarModels] = useState([]);
  const [services, setservices] = useState([]);
  const [locations, setlocations] = useState([]);
  const { navigateTo } = useContext(NavigatorContext);

  const getCitysData = useCallback(async () => {
    const result = await fetchByAttr({ status: "true" });
    if (result.status) {
      if (result.data?.length === 0) {
        showAlert({ type: "error", msg: t("errorMsg.fail.cityNotFound") });
      } else {
        const citiesList = [];
        result.data.forEach((e) => {
          e.value = e.code;
          e.label = e.name;
          citiesList.push(e);
        });
        setlocations(citiesList);
      }
    }
  }, [fetchByAttr, showAlert, t]);

  const getServicesData = useCallback(async () => {
    const result = await fetchServices();
    if (result.status) {
      if (result.data?.length !== 0) {
        setServices(result.data);
      }
    }
  }, [fetchServices, setServices]);

  const contextServices = getServices();
  useEffect(() => {
    let serviceList = [];
    contextServices
      .filter((e) => e.status === "publish")
      .forEach((e) => {
        e.value = e.slug;
        e.label = e.title;
        serviceList.push(e);
      });
    setservices(serviceList);
  }, [contextServices]);

  const getCarManufacturers = useCallback(async () => {
    const result = await getManufacturers();
    if (result.status) {
      if (result.data?.length !== 0) {
        let cb = [];
        result.data.forEach((e) => {
          e.value = e.slug;
          e.label = e.name;
          cb.push(e);
        });
        setcarBrands(cb);
      }
    }
  }, [getManufacturers]);
  const getCarManufacturerCars = useCallback(
    async (manufacturer) => {
      const result = await fetchCarByAttr({ manufacturer });
      if (result.data?.length !== 0) {
        let cm = [];
        result.data.forEach((e) => {
          e.value = e.modelKey;
          e.label = e.name + " " + e?.Segment;
          cm.push(e);
        });
        setcarModels(cm);
      }
    },
    [fetchCarByAttr]
  );
  const bookService = useCallback(() => {
    if (activeService) navigateTo({ route: "/service/" + activeService.slug });
  }, [activeService, navigateTo]);
  const selectCarBrand = useCallback(
    (e) => {
      setactiveCarBrand(e);
      getCarManufacturerCars(e.label);
    },
    [getCarManufacturerCars]
  );
  const selectCarModel = useCallback(
    (e) => {
      setActiveCar(e);
      setactiveCarModel(e);
    },
    [setActiveCar]
  );
  const selectLocation = useCallback(
    (e) => {
      setactiveLocation(e);
      setLocation(e);
    },
    [setLocation]
  );

  useEffect(() => {
    getCarManufacturers();
    if (getServices().length === 0) {
      getServicesData();
    }
    getCitysData();
  }, [getCarManufacturers, getServices, getServicesData, getCitysData]);

  return {
    activeCarBrand,
    activeCarModel,
    activeService,
    activeLocation,
    bookService,
    selectCarBrand,
    selectCarModel,
    selectService: setactiveService,
    selectLocation,
    carBrands,
    carModels,
    services,
    locations,
  };
};
